import React, { useRef, useEffect, useState } from 'react';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax

import { useQuery } from '@tanstack/react-query';

import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';

import { getAllDevices } from 'api/bks';

import 'mapbox-gl/dist/mapbox-gl.css';

// props-types is a library for typechecking of props
import PropTypes from "prop-types";

import Card from "@mui/material/Card";
import Box from '@mui/material/Box';

import { center, bbox, bboxPolygon } from "@turf/turf";
import geoViewport from "@mapbox/geo-viewport";

mapboxgl.accessToken = 'pk.eyJ1IjoiaGFycnltb250YW5vIiwiYSI6ImNqZWY0bDcyaTFkcGYzM28ydHFpaDJxaWcifQ.Wf7aNVePBRWZ9fMy_I81qw';

function getMapPolygons(group) {

    var polygon = {
        'type': 'FeatureCollection',
        'features': group.geojson
    }

    polygon.features.forEach(function (feature) {
        feature.properties = {
            group_id: group.group_id,
            name: group.name,
            uuids: group.uuids
        };
    })

    return polygon;
}

function GroupMap({ groups, settings, padding }) {

    const mapContainer = useRef(null);
    const map = useRef(null);

    useEffect(() => {
        var bounds = new mapboxgl.LngLatBounds();
        groups.forEach(function (group) {
            group.geojson.forEach(function (feature) {
                feature.geometry.coordinates.forEach(function (coords) {
                    coords.forEach(function (coord) {
                        bounds.extend(coord);
                    })
                })
            })
        });

        var map_settings = settings;
        map_settings.container = mapContainer.current;
        map.current = new mapboxgl.Map(map_settings);

        map.current.on('load', () => {

            // console.log(groups);
            groups.forEach(function (group) {
                var polygons = getMapPolygons(group);
                var existing_layer = map.current.getLayer('geojson-' + group.group_id);
                var existing_source = map.current.getSource('geojson-' + group.group_id);
                // console.log(existing_layer)
                // console.log(existing_source)

                if (!existing_source) {
                    map.current.addSource('geojson-' + group.group_id, {
                        type: 'geojson',
                        data: polygons
                    });
                }
                if (!existing_layer) {
                    map.current.addLayer({
                        id: 'geojson-' + group.group_id,
                        type: 'fill',
                        source: 'geojson-' + group.group_id,
                        paint: {
                            "fill-opacity": 0.2,
                            "fill-color": "red"
                        }
                    }).addLayer({
                        id: 'geojson-border-' + group.group_id,
                        type: 'line',
                        source: 'geojson-' + group.group_id,
                        paint: {
                            "line-color": "red",
                            "line-width": 2
                        }
                    });

                    // map.current.on('click', 'geojson-' + group.group_id, handleClick);
                    // map.current.on('mouseenter', 'geojson-' + group.group_id, handleMouseEnter);
                    // map.current.on('mouseleave', 'geojson-' + group.group_id, handleMouseLeave);
                }
            });

            map.current.fitBounds(bounds, { linear: true, padding, animation: { duraction: 20 } });
        });

    }, []); //mount

    useEffect(() => () => { //unmount
        // console.log(groups)
        groups.forEach(function (group) {
            var existing_layer = map.current.getLayer('geojson-' + group.group_id);
            if (existing_layer) {
                // map.current.off('click', 'geojson-' + group.group_id, handleClick);
                // map.current.off('mouseenter', 'geojson-' + group.group_id, handleMouseEnter);
                // map.current.off('mouseleave', 'geojson-' + group.group_id, handleMouseLeave);

                map.current.removeLayer('geojson-' + group.group_id);
                map.current.removeLayer('geojson-border-' + group.group_id);
                map.current.removeSource('geojson-' + group.group_id);
            }
        })

        map.current.remove();

    }, []);


    return (
        <Box component="div" ref={mapContainer} sx={{ height: '100%' }} />
    );
}

GroupMap.propTypes = {
    groups: PropTypes.array,
    settings: PropTypes.object,
    padding: PropTypes.number
};

export default GroupMap;